export default function (el) {
  return {
    unmount () {
    }
  }
}
